export default {
    site: '麦可易特网',
    ok: '确定',
    save: '保存',
    update: '更新',
    cancel: '取消',
    close: '关闭',
    editable: '进入编辑',
    type: '类型',
    state: '状态',
    valid: '有效',
    invalid: '无效',
    all: '全部',
    'kind-tips': '温馨提示',
    'built-in': '内置',
    'no-id': 'ID 有误, 请刷新后再试',
    customize: '自定义',
    understood: '知道了',
    activate: '前往激活',
    success: '操作成功',
    add: '新增',
    'add-now': '立刻添加',
    edit: '编辑',
    delete: '删除',
    reset: '重置',
    more: '更多',
    detail: '详情信息',
    code: '编码',
    'batch-delete': '批量删除',
    'delete-confirm': '确定删除当前所选项？',
    'delete-select': '请选择需要删除的选项',
    opt: '管理操作',
    key: '关键词',
    auth: '请求的资源需要认证 ( Unauthorized )',
    seek: '查询',
    yes: '是',
    no: '否',
    app: '应用',
    menu: '菜单',
    external: '外部',
    internal: '内部',
    view: '点击查看',
    back2top: '回到顶部',
    upload: {
        name: '上传',
        image: '上传图片',
        media: '上传媒体',
        file: '上传文件',
        view: '查看大图'
    },
    contact: {
        person: '联系人',
        info: '联系方式'
    },
    step: {
        prev: '上一步',
        next: '下一步'
    },
    week: {
        mon: '周一',
        tues: '周二',
        wed: '周三',
        thur: '周四',
        fri: '周五',
        sat: '周六',
        sun: '周日'
    },
    'no-data': '暂无符合条件的数据',
    theme: {
        light: '浅色',
        dark: '深色'
    },
    notice: {
        'good-day': '美好的一天',
        'no-bugs': '无缺陷',
        'no-meeting': '无会议',
        'no-business': '无需求',
        fine: '诸事皆宜'
    },
    search: {
        name: '搜索',
        searching: '搜索中 ···',
        key: '请输入要搜索的关键词',
        components: '搜索组件',
        fail: {
            message: '源数据获取失败，无法完成搜索',
            code: '错误代码：',
            reason: '错误原因：',
            api: '接口发生了不可预知的错误'
        }
    },
    page: {
        prefix: '第',
        prev: '上一页',
        next: '下一页',
        unit: '页',
        strip: '条',
        total: '共'
    },
    screenfull: {
        error: '全屏失败，请刷新后再试',
        capture: '未获取到要全屏展示的内容',
        support: '当前浏览器不支持全屏操作'
    },
    captcha: {
        loading: '正在加载验证码 ···',
        init: '正在初始化验证码 ···',
        'init-error': '初始化接口有误，请稍候再试',
        click: '点击按钮进行验证',
        checking: '智能检测中 ···',
        pass: '通过验证',
        tip: '错误提示',
        error: '已连续错误达 {num} 次，请稍候再试',
        move: '请移动滑块，完成验证',
        drag: '拖动左边滑块完成上方拼图',
        dragging: '拖动滑块将悬浮图像正确拼合',
        close: '关闭验证',
        refresh: '刷新验证',
        feedback: '帮助反馈',
        provide: '提供技术支持',
        success: '{take}s速度完成图片拼合验证',
        flatten: '拖动滑块拼合图片',
        verify: '就能验证成功哦'
    },
    password: {
        lv1: '弱不禁风',
        lv2: '平淡无奇',
        lv3: '出神入化',
        lv4: '登峰造极',
        tip: '需包含字母、数字及特殊字符两种或以上组合',
        placeholder: '请输入密码',
        repeat: '请再次输入密码',
        strong: '密码强度',
        size: '{min}-{max}个字符，区分大小写，前后无空格',
        format: '字母、数字、英文、下划线等其他特殊字符',
        different: '两次密码输入不一致',
        setting: '请设置密码',
        least: '密码长度至少为{min}个字符'
    },
    anchor: {
        text: '锚点 Anchor',
        close: '关闭锚点链接',
        stick: {
            yes: '开启固定悬浮',
            no: '取消固定悬浮'
        }
    },
    passport: {
        forget: '忘记密码',
        remember: '保持登录',
        'no-account': '没有账号？',
        'has-account': '已有帐号？',
        verify: '请点击按钮进行验证码校验',
        username: '请输入用户名 / 邮箱地址 / 手机号码',
        email: '请输入邮箱地址',
        password: '请输入登录密码',
        binding: '立即绑定',
        code: '请输入验证码',
        sent: '验证码已发送',
        'resend-downtime': '{sec}s后可重新发送',
        'resend-tip': '验证码已发送至密保邮箱 {email}',
        resend: '重新发送',
        update: '更新密码',
        success: '密码重置成功',
        illegal: '当前操作不被允许',
        login: {
            title: '登录',
            sign: '立即注册',
            socialite: '快捷登录方式',
            back: '返回登录'
        },
        register: {
            title: '注册',
            sign: '前往登录',
            account: '请设置用户账号',
            'email-valid': '请输入有效的邮箱地址',
            format: '仅允许字母+数字，4-16 个字符，且以字母开头',
            go: '前往注册',
            tips: {
                special: "<span class='red'>&lt; 特别提醒 &gt;</span> 登录用户名，一旦设置，则无法更改。",
                structure: "- 由 <span class='theme'>字母</span>、<span class='theme'>数字</span> 或 <span class='theme'>下划线</span> 组成。",
                start: "- 只能以 <span class='theme'>字母开头</span>，例如：makeit。",
                length: "- 用户名长度为 <span class='theme'>4-16</span> 个字符。"
            }
        }
    },
    history: {
        close: {
            all: '关闭全部',
            left: '关闭左侧',
            right: '关闭右侧',
            other: '关闭其它'
        }
    },
    language: {
        'zh-cn': '简体中文',
        'en-us': '英文',
        list: {
            zh: '中文',
            en: '英文',
            jp: '日语',
            kor: '韩语',
            fra: '法语',
            spa: '西班牙语',
            th: '泰语',
            ara: '阿拉伯语',
            ru: '俄语',
            pt: '葡萄牙语',
            de: '德语',
            it: '意大利语',
            el: '希腊语',
            nl: '荷兰语',
            pl: '波兰语',
            bul: '保加利亚语',
            est: '爱沙尼亚语',
            dan: '丹麦语',
            fin: '芬兰语',
            cs: '捷克语',
            rom: '罗马尼亚语',
            slo: '斯洛文尼亚语',
            swe: '瑞典语',
            hu: '匈牙利语',
            cht: '繁体中文',
            vie: '越南语'
        },
        current: '当前语系：',
        system: '系统内置',
        add: '新增配置',
        key: '语言编码',
        'add-title': '新增语言配置',
        'update-title': '更新语言配置',
        management: '语系管理',
        'add-language': '新增语系',
        'display-language': '显示名称',
        'is-default': '设为默认语系',
        'is-translate': '是否自动翻译',
        target: '翻译目标语言',
        default: '设为默认',
        auto: '调用百度翻译 API 进行自动翻译，请预先配置 APPID 等参数',
        'default-tip': '默认语系将作为新增语系的数据基础，新语系可选择是否生成一套与默认语系当前语言配置相同 Key 值的配置属性，同时可选自动翻译功能，调用百度翻译 API 所支持的语言内容进行自动翻译。',
        'default-language': '默认语系',
        'no-data': '暂无设定语系',
        error: {
            key: {
                empty: '请输入关键词',
                exist: '关键词已存在，请重新输入',
                error: '关键词有误，请重新输入'
            },
            language: '请输入语系显示名称',
            'no-data': '请先选定语系后再设定为默认',
            'is-default': '请选择是否为默认语系选项',
            default: '当前已是默认语系，无需再次设定'
        },
        placeholder: {
            key: '语言编码，如简体中文的关键词为: zh-cn',
            language: '语系显示名称，如：简体中文',
            search: '请输入待搜索关键词 ...',
            current: '请选择语系',
            config: {
                key: '请输入语言配置的关键词',
                value: '请输入语言配置关键词对应的语言内容'
            }
        },
        translate: {
            config: '调用自动翻译，请预先配置百度翻译的 APPID 及 密钥 Key 值'
        }
    },
    menus: {
        add: '新增菜单',
        update: '更新菜单',
        name: '菜单名称',
        subname: '菜单子标题',
        up: '上级菜单',
        app: '所属应用',
        type: '菜单类型',
        icon: '菜单图标',
        path: '访问路径',
        attrs: '菜单属性',
        top: '一级菜单',
        sub: '子菜单',
        unknown: '未知类型',
        auth: '授权标识',
        policy: '授权策略',
        btn: '按钮/权限',
        btnName: '按钮名称',
        lang: '多语言 Key 值',
        page: '前端组件',
        redirect: '默认跳转地址',
        weight: '排序值',
        open: '打开方式',
        router: '路由菜单',
        hide: '隐藏路由',
        addSub: '添加子菜单',
        policies: {
            invisible: '不可见',
            visible: '仅可见',
            accessible: '可见/可访问'
        },
        icons: {
            directional: '方向类图标',
            tips: '提示类图标',
            edit: '编辑类图标',
            data: '数据类图标',
            brands: '品牌类图标',
            generic: '通用类图标'
        },
        placeholder: {
            search: '请输入待搜索的菜单名称',
            name: '请输入菜单名称，如：控制台',
            btn: '请输入按钮/权限名称，如：新增',
            subname: '请输入菜单子标题，如：Dashboard',
            path: '请输入菜单访问路径，如：/dashboard',
            page: '请输入菜单对应的前端组件，如：views/dashboard',
            redirect: '请输入默认跳转地址',
            icon: '请选择菜单图标',
            up: '请选择上级菜单',
            lang: '多语言菜单 key 值',
            auth: '请输入唯一的授权标识, 如: personal:data'
        }
    },
    apps: {
        add: '新增应用',
        update: '更新应用',
        delete: '删除应用',
        name: '应用名称',
        code: '应用编码',
        logo: '应用图标',
        state: '应用状态',
        desc: '应用描述',
        auth: '授权登录',
        link: '应用链接',
        up: '上架',
        down: '下架',
        placeholder: {
            search: {
                name: '请输入待搜索的应用名称',
                code: '请输入待搜索的应用编码'
            },
            contact: {
                person: '请输入应用联系人',
                info: '请输入应用联系人的联系方式'
            },
            name: '请输入应用名称',
            code: '请输入应用编码',
            desc: '请输入应用描述',
            state: '请选择应用状态',
            auth: '该应用是否支持授权登录',
            logo: '请上传应用 logo',
            link: '请输入应用访问入口链接'
        }
    },
    api: {
        create: '尚未设置{name}创建接口',
        update: '尚未设置{name}更新接口',
        delete: '尚未设置{name}删除接口',
        common: '尚未设置相应接口地址'
    }
};
